import React, { useState } from 'react';
import { AiOutlineMenu, AiOutlineSearch, AiOutlineClose, AiFillHome, AiOutlineLogout } from "react-icons/ai";
import { FaPhone, FaInfoCircle } from "react-icons/fa";
import { SlUser, SlLogin, SlPaperClip, SlArrowRight, SlArrowDownCircle } from "react-icons/sl";  // Add new icons here
import { Link, useNavigate } from 'react-router-dom';
import { Menu as MenuIcon, Search as SearchIcon, Close as CloseIcon, Home as HomeIcon, Logout as LogoutIcon, Person as PersonIcon, Login as LoginIcon, ShoppingCart as ShoppingCartIcon, Description as DescriptionIcon, Dashboard as DashboardIcon, ContactPhone as ContactPhoneIcon, Info as InfoIcon } from "@mui/icons-material";

import { useContextSelector } from "use-context-selector";
import toast, { Toaster } from "react-hot-toast";
import { StateContext } from "../contexts/StateContext";
import { ADMIN, PUPIL, ACCESS_TOKEN, ADMIN_TOKEN, SHOPADMIN, SHOPADMIN_TOKEN, USERNAMEWITHMAIL } from "../config/Config";
import { data } from '../data/data';
import Logo from "../assets/logo1.png";

const Navbar = () => {
    const [nav, setNav] = useState(false);
    const [showUser, setShowUser] = useState(false);
    const navigate = useNavigate();

    const isLoggedIn = useContextSelector(StateContext, (state) => state.isLoggedIn);
    const setRole = useContextSelector(StateContext, (state) => state.setRole);
    const role = useContextSelector(StateContext, (state) => state.role);
    const setIsLoggedIn = useContextSelector(StateContext, (state) => state.setIsLoggedIn);
    const loggedInUserEmail = useContextSelector(StateContext, (state) => state.userEmail);

    // Log the value of USERNAMEWITHMAIL to verify it's correct
    console.log("Logged-in user email:", localStorage.getItem(USERNAMEWITHMAIL));

    // Filter data based on logged-in user's shop email
    const filteredData = data.filter(item => {
        if (localStorage.getItem(USERNAMEWITHMAIL) && item.shopEmail) {
            console.log("Logged-in user email:", localStorage.getItem(USERNAMEWITHMAIL));
            console.log("Comparing with shopEmail:", item.shopEmail);
            return item.shopEmail.trim().toLowerCase() === localStorage.getItem(USERNAMEWITHMAIL).trim().toLowerCase();
        }
        return false;
    });

    console.log("Filtered data based on shopEmail:", filteredData);

    const logout = () => {
        localStorage.clear();
        localStorage.removeItem(ACCESS_TOKEN);
        localStorage.removeItem(ADMIN_TOKEN);
        localStorage.removeItem(SHOPADMIN_TOKEN);
        setIsLoggedIn(false);
        setShowUser(false);
        setRole("");
        toast.success("Logout successfully");
        navigate("/");
    };

    const handleNavigation = (path) => {
        setNav(false);
        navigate(path);
    };

    return (
        <div className="max-w-[1640px] mx-auto flex justify-between items-center p-4 font-sans">

            <div className="flex items-center">
                <div onClick={() => setNav(!nav)} className="cursor-pointer">
                    <MenuIcon fontSize="large" />
                </div>

                <div className="flex items-center space-x-2">
                    <img src={Logo} alt="Logo" className="h-10 w-10 sm:h-18 sm:w-14 lg:h-16 lg:w-16" />
                    <h1 className="text-xl sm:text-3xl lg:text-4xl px-2 text-blue-400">
                        HARE KRISHNA TRADERS
                    </h1>
                </div>
                <div className="hidden lg:flex items-center bg-gray-200 rounded-full p-1 text-[14px]">
                    <p className="bg-black text-white rounded-full p-2">Delivery</p>
                </div>
            </div>

            <div className="bg-gray-200 rounded-full flex items-center px-2 w-[200px] sm:w-[400px] lg:w-[500px]">
                <AiOutlineSearch size={20} />
                <input className="bg-transparent p-2 w-full focus:outline-none" type="text" placeholder="Search Ice Cream, Milk" />
            </div>

            {nav ? <div onClick={() => setNav(!nav)} className="bg-black/80 fixed w-full h-screen z-10 top-0 left-0"></div> : ''}

            <div className={nav ? "fixed top-0 left-0 w-[300px] h-screen bg-white z-10 duration-300 overflow-y-auto" : "fixed top-0 left-[-100%] w-[300px] h-screen bg-white z-10 duration-300 overflow-y-auto"}>

                <AiOutlineClose onClick={() => setNav(!nav)} size={30} className="absolute right-4 top-4 cursor-pointer" />
                <h2 className="text-xl p-4">HARE KRISHNA TRADERS</h2>
                <nav>
                    <ul className="flex flex-col p-4 text-gray-800">
                        <li onClick={() => handleNavigation('/')} className="text-xl py-4 flex cursor-pointer">
                            <AiFillHome size={25} className="mr-4" /> Home
                        </li>

                        {isLoggedIn && (
                            <>
                                <li onClick={() => handleNavigation('/profile')} className="text-xl py-4 flex cursor-pointer">
                                    <SlUser size={25} className="mr-4" /> Profile
                                </li>

                                {role === ADMIN && (
                                    <>
                                        <li onClick={() => handleNavigation('/inventorytap')} className="text-xl py-4 flex cursor-pointer">
                                            <SlLogin size={25} className="mr-4" /> Inventory
                                        </li>
                                        <li onClick={() => handleNavigation('/invoiceDashboard')} className="text-xl py-4 flex cursor-pointer">
                                            <SlArrowDownCircle size={25} className="mr-4" /> Invoice Dashboard
                                        </li>
                                        <li onClick={() => handleNavigation('/invoiceDashboardNew')} className="text-xl py-4 flex cursor-pointer">
                                            <SlArrowDownCircle size={25} className="mr-4" /> Invoice DashboardNew
                                        </li>
                                        <li onClick={() => handleNavigation('/gstDashboard')} className="text-xl py-4 flex cursor-pointer">
                                            <SlArrowDownCircle size={25} className="mr-4" /> GST Dashboard
                                        </li>
                                        <li onClick={() => handleNavigation('/productadd')} className="text-xl py-4 flex cursor-pointer">
                                            <SlPaperClip size={25} className="mr-4" /> Items
                                        </li>
                                        <li onClick={() => handleNavigation('/sale')} className="text-xl py-4 flex cursor-pointer">
                                            <SlLogin size={25} className="mr-4" /> Sale
                                        </li>
                                        <li onClick={() => handleNavigation('/admindashboard')} className="text-xl py-4 flex cursor-pointer">
                                            <SlLogin size={25} className="mr-4" /> Reports
                                        </li>
                                        <li onClick={() => handleNavigation('/admindashboard')} className="text-xl py-4 flex cursor-pointer">
                                            <SlArrowDownCircle size={25} className="mr-4" /> Admin Dashboard
                                        </li>
                                        <li onClick={() => handleNavigation('/userdashboard')} className="text-xl py-4 flex cursor-pointer">
                                            <SlUser size={25} className="mr-4" /> Your Orders
                                        </li>
                                    </>
                                )}

                                {role === PUPIL && (
                                    <li onClick={() => handleNavigation('/userdashboard')} className="text-xl py-4 flex cursor-pointer">
                                        <SlLogin size={25} className="mr-4" /> Your Orders
                                    </li>
                                )}

                                {filteredData.length > 0 && (
                                    <li onClick={() => handleNavigation('/ownshopdashboard')} className="text-xl py-4 flex cursor-pointer">
                                        <SlLogin size={25} className="mr-4" /> Own Shop Orders
                                    </li>
                                )}

                                {role === SHOPADMIN && (
                                    <>
                                        <li onClick={() => handleNavigation('/malligamessdashboard')} className="text-xl py-4 flex cursor-pointer">
                                            <SlLogin size={25} className="mr-4" /> Malliga Mess Dashboard
                                        </li>
                                        <li onClick={() => handleNavigation('/userdashboard')} className="text-xl py-4 flex cursor-pointer">
                                            <SlUser size={25} className="mr-4" /> Your Orders
                                        </li>
                                    </>
                                )}

                                <li onClick={logout} className="text-xl py-4 flex cursor-pointer">
                                    <AiOutlineLogout size={25} className="mr-4" /> Logout
                                </li>
                            </>
                        )}

                        {!isLoggedIn && (
                            <>
                                <li onClick={() => handleNavigation('/signin')} className="text-xl py-4 flex cursor-pointer">
                                    <SlLogin size={25} className="mr-4" /> Sign In
                                </li>
                                <li onClick={() => handleNavigation('/signup')} className="text-xl py-4 flex cursor-pointer">
                                    <SlUser size={25} className="mr-4" /> Sign Up
                                </li>
                            </>
                        )}

                        <li onClick={() => handleNavigation('/contact')} className="text-xl py-4 flex">
                            <FaPhone size={25} className="mr-4" /> Contact Us
                        </li>
                        <li onClick={() => handleNavigation('/about')} className="text-xl py-4 flex cursor-pointer">
                            <FaInfoCircle size={25} className="mr-4" /> About Us
                        </li>
                    </ul>
                </nav>
            </div>

            <Toaster position="bottom-right" reverseOrder={false} toastOptions={{
                error: {
                    duration: 6000,
                    style: {
                        background: "#FF4136",
                        color: "#fff",
                    },
                },
                success: {
                    duration: 6000,
                    style: {
                        background: "#008000",
                        color: "#fff",
                    },
                },
            }} />
        </div>
    );
};

export default Navbar;
